import features from "./featureToggles.json";

type Feature = { [key: string]: { [key: string]: boolean } };

const isFeatureEnabled = (name: string) => {
  const env = process.env.REACT_APP_ENVIRONMENT;

  if (env) {
    const envFeature = (features as Feature)[env];
    if (!envFeature) return false;
    return (features as Feature)[env] != null && envFeature[name];
  }
  return false;
};

const keys = {
  QR_GENERATE_BY_ENTITLEMENT_ID: "qrCodeGenerateByEntitlementId",
  TRANSFER_BADGE: "transferBadge",
  SHORTENED_FREYA_BADGE_ENDPOINT: "shortenedFreyaBadgeEndpoint"
};

const FeatureToggles = { isFeatureEnabled, keys };
export default FeatureToggles;
